'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const fastdom=require('fastdom');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

PointPlotterDirective=class PointPlotterDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['points','pointHeight','plotArea','horizontalAxis','verticalMargin','pointTopY'];
}
get textBindings(){
return['class','mask','timeProperty'];
}

get controller(){
return PointPlotterController;
}};let


PointPlotterController=class PointPlotterController{
static get $inject(){
return['$scope','$element','$compile'];
}

constructor($scope,$element,$compile){
this._$scope=$scope;
this._$element=$element;
this._$compile=$compile;

this.hitAreaWidth=0;

$scope.$watch('controller.plotArea',()=>{
if(_.exists(this.plotArea)){
this.plotArea.registerPlotter(this);

}
});
}

_getPointInfos(){
return this.points.map(point=>({
point,
x:this.horizontalAxis.scale(point.getTime())}));

}

_getLineInfos(){
let actualPointHeight=_.exists(this.pointHeight)?
this.pointHeight:
this.plotArea.graphAreaDimensions.height;
let pointTopY=this.plotArea.graphAreaDimensions.height-actualPointHeight;

if(_.exists(this.pointTopY)){
pointTopY=this.pointTopY;
actualPointHeight-=this.pointTopY;
}

if(_.exists(this.verticalMargin)){
pointTopY+=this.verticalMargin;
actualPointHeight-=this.verticalMargin*2;
}

return{
x1:({x})=>x,
x2:({x})=>x,
y1:pointTopY,
y2:(this.verticalMargin||0)+actualPointHeight,
class:this.class};

}

_getHitAreaInfos(){
const lineInfos=this._getLineInfos();
return{
x:({x})=>x-this.hitAreaWidth/2,
y:lineInfos.y1,
width:this.hitAreaWidth,
height:lineInfos.y2,
fill:'transparent',
class:this.class};

}

_drawLines(pointGroup,pointInfos){
pointGroup.selectAll('line').
data(pointInfos).
enter().
append('line').
attr(this._getLineInfos());
}

_drawHitAreas(pointGroup,pointInfos){
if(_.exists(this.hitAreaWidth)&&this.hitAreaWidth>0){
pointGroup.selectAll('rect').
data(pointInfos).
enter().
append('rect').
attr(this._getHitAreaInfos()).
append('svg:title').
text(pi=>pi.tooltipText?`${pi.tooltipText}`:void 0);
}
}

_precompileStep(){

return;
}

_drawMask(pointGroup){
if(_.exists(this.mask)&&this.mask.length>0){
pointGroup.
attr('mask',`url(#${this.mask}-${this.plotArea.id})`).
append('rect').attr({

height:'100%',
width:'100%',
fill:'none'});

}
}

redraw(){
if(!_.exists(this.horizontalAxis||this.horizontalAxis.scale||this.plotArea.svgElement)){
return;
}

fastdom.mutate(()=>{
const svgContainer=d3.select(this.plotArea.svgElement);
const pointGroup=svgContainer.append('g');

pointGroup.attr({
class:this.class,
transform:`translate(0, ${this.plotArea.graphAreaBoundaries.top})`});


const pointInfos=this._getPointInfos(this.points);
this._drawLines(pointGroup,pointInfos);
this._drawHitAreas(pointGroup,pointInfos);
this._precompileStep(pointGroup);
this._drawMask(pointGroup);

if(this._childScope){
this._childScope.$destroy();
}

this._childScope=this._$scope.$new();
this._compiledHtml=this._$compile(this.plotArea.svgElement)(this._childScope);
});
}};


module.exports=PointPlotterDirective;
module.exports.Controller=PointPlotterController;
//# sourceMappingURL=pointPlotterDirective.js.map
